import { useState, useEffect } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputTextArea from "../../helpers/InputTextArea";
import InputChecbox from "../../helpers/InputCheckbox";

import PlTitle from "../../elements/PlTitle";

import back from "../../back.png";

function GroupEdit(props)
{

    

       const [errTab, setErrTab] = useState([]);  //z info od serwera..

       const [emps, setEmps] = useState(null); //pracownicy..

       const [row, setRowX] = useState({
            id: props.row.id,
            nazwa:  props.row.nazwa,
            rok_szkolny: props.row.rok_szkolny,
            wiek_od: props.row.wiek_od,
            wiek_do: props.row.wiek_do,
            max_ilosc_dzieci: props.row.max_ilosc_dzieci,    
            opis: props.row.opis,  
            sala: props.row.sala,
            pietro: props.row.pietro,
            emps: props.row.emps,
            emps_selected: [],
        });
        var tmpRow = row;


        const [checked, setChecked] = useState(false);
        const handleChange = () => {
            setChecked(!checked);
          };


        const valChecker = (fields) => {

            var allValid = true;
    
                  
            console.log(JSON.stringify(fields) );

            Object.entries(fields).forEach(function(entry) {
    
                var xKey    = entry[0];
                var xValue  = entry[1];                    

                var xValidName = xKey + "_valid";
    
                if(fields[xValidName] == false)
                {
                    allValid = false;
                    console.log("Error field: " + xKey);
                }
                
              });
            
              return allValid;
    
        }
    

            const valChangeListener = (filedName, val, correct, msg) => {         
                //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                var tabCheck = filedName.split('@');
                if(tabCheck.length == 2)
                {
                    var tabName = tabCheck[0];
                    var tabInx  = tabCheck[1];
                    var tRef = row[tabName];

                   // console.log("tRef", tRef);

                    if(  tRef[tabInx]["selected"] == "0"   )
                    {
                    tRef[tabInx]["selected"] = "1";
                    }else tRef[tabInx]["selected"] = '0';


                    tmpRow[tabName] = tRef;     
                    setRowX(  JSON.parse(JSON.stringify(tmpRow)) );  
        
                    //setRowX( {...row, [tabName]:tRef } );   
                    return;
                }
        
            
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;         
                setRowX(  JSON.parse(JSON.stringify(tmpRow)) );    
            
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );    
    

            
            }   
        
        
            const goNextNew = () => {
                console.log("goNext");
                saveData();
            }
    
        const saveData = () => {


 

            if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }
        
    
            props.mainView.setProgress(-2);
    
            var req = row;
    
            fetch( Config.url + '/rest_v1_kids,groups_update', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane", "ok" , null);                        
                            Config.removeFromBuffer(Config.cache_grups, props.userData);
                          //  props.onBack();
                        }else
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }
     


        const getEmps = () => {
        
            var req = {            
            };
    
            fetch( Config.url + '/rest_v1_kids,emps', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             

                        setEmps(res);  

                   
                        var arr = new Array();

                        for(var k=0; k < res.result.length; k++)
                        {
                            var selected = "0";

                            for(var m=0; m < row.emps.length; m++)
                            {
                                if(row.emps[m].id == res.result[k].id) {  selected = "1"; break;  }
                            }

                            arr.push({
                                id: res.result[k].id,
                                imie: res.result[k].imie,
                                nazwisko: res.result[k].nazwisko,
                                selected: selected,
                            });
                        }

                       setRowX( {...row, ["emps_selected"]:arr  } );    

                       console.log("Arr", arr);

             } )
             .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
        }


        if(emps == null)
            {   
                getEmps();
                return (
                    <div></div>
                );        
            }


       
 
        return (
                 <div className="view_content">

                        <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>
                    
                        
                        <form className="eForm bg_center">

                                     


                                    <div className="form_tab">

                                        <div className="form_more_btn">                                                                              
                                                 <label className="switch" title={props.userData.dic.showmore}>                               
                                                    <input type="checkbox" checked={checked}  onChange={handleChange}/>
                                                    <span className="slider round"></span>
                                                 </label>                         
                                        </div>

                                           <div className="form_tab_title">Informacje ogólne:</div>

                                            <div className="form_control">
                                                <div className="fieldName">Nazwa*</div>
                                                <InputText   userData={props.userData} value={row.nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: np. Smerfiki"} className=' w200 ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Rok szkolny*</div>
                                                <InputText   userData={props.userData} value={row.rok_szkolny} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="rok_szkolny" placeholder={"Rok szkolny: np. 2024/2025"} className=' w200 ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                <div className="fieldName">Wiek OD*</div>
                                                <InputDecimal   userData={props.userData} value={row.wiek_od} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wiek_od" placeholder={"Wiek: np. 3"} className=' w100 ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Wiek DO*</div>
                                                <InputDecimal   userData={props.userData} value={row.wiek_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wiek_do" placeholder={"Wiek: np. 6"} className=' w100 ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Maksymalna ilość dzieci w grupie*</div>
                                                <InputDecimal   userData={props.userData} value={row.max_ilosc_dzieci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="max_ilosc_dzieci" placeholder={"Max dzieci: np. 25"} className=' w100 ' req='1' firstUp="1" />
                                            </div>


                                          

                                    </div>


                                    { checked &&
                                                <div className="form_tab">
                                  
                                                    <div className="form_tab_title">Przypisane pomieszczenie</div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Nazwa sali</div>
                                                        <InputText   userData={props.userData} value={row.sala} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sala" placeholder={"Sala: np. III"} className=' w200 ' req='0' firstUp="0" />
                                                    </div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Piętro</div>
                                                        <InputText   userData={props.userData} value={row.pietro} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="pietro" placeholder={"Piętro: np. parter"} className=' w200 ' req='0' firstUp="0" />
                                                    </div>


                                                    <div className="form_split"></div>

                                                    <div className="form_control">
                                                        <div className="fieldName">Informacje dodatkowe</div>
                                                        <InputTextArea   userData={props.userData} value={row.opis} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="opis" placeholder={"Opis:"} className=' w300 ' req='0' firstUp="0" />
                                                    </div>
                                                </div>
                                            }


                                    <div className="form_tab">

                                             <div className="form_tab_title">Przypisane osoby / opiekunki:</div>

                                                {
                                                    row.emps_selected.map( (item, ix) => {                                        

                                                        
                                                            //---------------------------
                                                            var xChaced = false;

                                                            if(item.selected == "1") xChaced = true;
                                                            //---------------------------

                                                            return (
                                                                <div className="form_control">                                                         
                                                                      <InputChecbox  title={item.nazwisko + " " + item.imie}  err={errTab}  userData={props.userData}  checked={xChaced} value={item.id} valChange={valChangeListener}  name={ "emps_selected@"+ix  }   className=' ' req='0' />
                                                                </div>
                                                            )

                                                    } )
                                                }
                                    </div>



                                    <div className="form_split"></div>

                                    <div className="form_btn">
                                            <div className="btn" onClick={saveData}>zapisz</div>
                                            &nbsp;&nbsp;
                                            <div className="btn" onClick={props.onBack}    > anuluj</div>
                                    </div>


                        </form>

                </div>
        )
}


export default GroupEdit;